// ── 권한 배정 페이지 스타일 상수 ─────────────────────────────────────────────
// PermissionAssignment.jsx 의 스타일을 별도 모듈로 분리.
// 모든 스타일은 named export 로 제공된다.

// ── 페이지 헤더 카드 ──────────────────────────────────────────────────────────

// 페이지 제목

// 위임 범위 제한 안내 문구 (isDelegate=true 일 때만 표시)

// 배정 가능 항목이 없을 때 전체 페이지 빈 상태 안내
export const emptyPageStyle = {
  background: 'var(--bg-card)',
  borderRadius: 12,
  border:       '1px solid var(--border)',
  padding:      32,
  textAlign:    'center',
  color:        'var(--text-muted)',
  fontSize:     14,
};

// ── 2-컬럼 레이아웃 ───────────────────────────────────────────────────────────
// isMobile=true 이면 1컬럼, false 이면 좌측 패널(최대 280px) + 우측 패널
export const layoutStyle = (isMobile) => ({
  display:             'grid',
  gridTemplateColumns: isMobile ? '1fr' : 'minmax(210px, 280px) minmax(0, 1fr)',
  gap:                 12,
});

// ── 패널 공통 스타일 ─────────────────────────────────────────────────────────
// 좌측 (배정 유형·업무/기능 선택) / 우측 (직원 배정) 패널 공통
export const panelStyle = {
  border:       '1px solid var(--border)',
  borderRadius: 12,
  background: 'var(--bg-card)',
  padding:      16,
};

// 섹션 소제목 (UPPERCASE, 작은 회색)
export const titleStyle = {
  margin:        '0 0 10px 0',
  fontSize:      11,
  fontWeight:    600,
  color:         'var(--text-muted)',
  textTransform: 'uppercase',
  letterSpacing: '0.06em',
};

// ── 버튼 스타일 (동적 — isDelegate 테마 색상 적용) ──────────────────────────

// 배정 유형 선택 버튼 (업무 배정 / 기능 배정)
export const kindButtonStyle = (active, color) => ({
  border:      `1px solid ${active ? color : 'var(--border)'}`,
  borderRadius: 10,
  padding:     '10px 12px',
  textAlign:   'left',
  fontWeight:   700,
  fontSize:     13,
  background: active ? color : 'var(--bg-card)',
  color:        active ? '#fff' : 'var(--text-sub)',
  cursor:       'pointer',
});

// 업무 항목 선택 버튼
export const taskButtonStyle = (active, color) => ({
  border:      `1px solid ${active ? color : 'var(--border)'}`,
  borderRadius: 8,
  padding:     '9px 12px',
  textAlign:   'left',
  fontWeight:   600,
  fontSize:     13,
  background: active ? color : 'var(--bg-card)',
  color:        active ? '#fff' : 'var(--text-sub)',
  cursor:       'pointer',
});

// 기능셋 카드 버튼
export const featureSetCardStyle = (active, color) => ({
  border:      `1px solid ${active ? '#bfdbfe' : 'var(--border)'}`,
  borderLeft:   active ? `3px solid ${color}` : '1px solid var(--border)',
  borderRadius: 10,
  background: active ? 'rgba(37,99,235,0.10)' : 'var(--bg-card)',
  textAlign:   'left',
  padding:      active ? '10px 12px 10px 10px' : '10px 12px',
  cursor:       'pointer',
});

// ── 직원 목록 영역 스타일 ──────────────────────────────────────────────────────

// 이름/아이디/부서 검색 입력
export const searchInputStyle = {
  border:      '1px solid var(--border)',
  borderRadius: 8,
  padding:     '9px 12px',
  width:       '100%',
  fontSize:     13,
  color:        'var(--text)',
  background: 'var(--bg-card)',
  marginBottom: 10,
  boxSizing:   'border-box',
};

// 미배정/배정 두 컬럼 분할 레이아웃
export const splitStyle = (isMobile) => ({
  display:             'grid',
  gridTemplateColumns:  isMobile ? '1fr' : '1fr 1fr',
  gap:                  10,
});

// 미배정/배정 각 리스트 패널
export const listPanelStyle = {
  border:       '1px solid var(--border)',
  borderRadius: 10,
  minHeight:    340,
  maxHeight:    540,
  overflowY:   'auto',
  background: 'var(--bg-card)',
};

// 리스트 패널 상단 고정 헤더 (미배정 직원 / 배정된 직원)
export const listTitleStyle = {
  position:      'sticky',
  top:            0,
  background:    'var(--bg-subtle)',
  padding:       '8px 12px',
  borderBottom:  '2px solid var(--border)',
  fontSize:       11,
  fontWeight:     600,
  color:         'var(--text-muted)',
  textTransform: 'uppercase',
  letterSpacing: '0.04em',
};

// 직원 행 레이아웃
export const rowStyle = {
  display:        'flex',
  alignItems:     'center',
  justifyContent: 'space-between',
  gap:             8,
  padding:        '9px 12px',
  borderBottom:   '1px solid var(--bg-subtle)',
};

// 직원 이름
export const nameStyle = { fontWeight: 600, fontSize: 13, color: 'var(--text)' };

// 직원 아이디·부서 보조 텍스트
export const metaStyle = { fontSize: 11, color: 'var(--text-muted)', marginTop: 2 };

// 배정 버튼 (테마 색상 적용)
export const actionBtnStyle = (color) => ({
  border:       `1px solid ${color}`,
  background:    color,
  color:        '#fff',
  borderRadius:  7,
  padding:      '5px 12px',
  fontWeight:    600,
  fontSize:      12,
  cursor:       'pointer',
  whiteSpace:   'nowrap',
  flexShrink:    0,
});

// 배정 해제 버튼
export const removeBtnStyle = {
  border:       '1px solid var(--border)',
  background: 'var(--bg-card)',
  color:        'var(--text-sub)',
  borderRadius:  7,
  padding:      '5px 12px',
  fontWeight:    600,
  fontSize:      12,
  cursor:       'pointer',
  whiteSpace:   'nowrap',
  flexShrink:    0,
};

// 리스트 내 빈 상태 안내 텍스트
export const emptyStyle = {
  padding:   16,
  color:     'var(--text-muted)',
  textAlign: 'center',
  fontSize:  13,
};
